import React, { useState, useContext } from "react";
import { Box, useToast } from "@chakra-ui/react";
import { SuppliersContext } from "../../Context/SuppliersContext";
import FormModal from "../../Common/FormModal";

const DeleteProduct = ({ isOpen, setIsOpen, product, action }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();

  const handleSubmit = () => {
    action(product);
    setIsOpen(false);
  };

  return (
    <FormModal
      title={"Eliminar artículo"}
      action={() => handleSubmit()}
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      isSubmitting={isSubmitting}
      actionButton="Borrar"
    >
      <Box w="100%" mr="1">
        ¿Desea borrar el artículo?
      </Box>
    </FormModal>
  );
};

export default DeleteProduct;
